import React from 'react';

import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import '@src/css/bootstrap.scss';

import './contactCard.scss';

/**
 * ## ContactCard
 *
 * Contact card two-thirds of the screen
 * @param {string} title - title for the card
 * @param {string} content - content text for the card
 * @param {object} link - href and text string for the card
 * @param {string} imageSource - imageSource for the card image
 * @param {boolean} flexReverse - imageSource for the card image
 */
export const ContactCard = (props) => {
    const {
        id = '',
        title = '',
        content = '',
        link = '#',
        imageSource = '',
    } = props;

    return (
        <Card id={id} className="contact-card-container rounded-0">
            <Row>
                <Col sm={12} md={6} className="pr-md-0 contact-card-first-column">
                    <h2>
                        {title}
                    </h2>
                    <p>
                        {content}
                    </p>
                    <div>
                        <Button href={link.link} variant="outline-primary">
                            {link.text}
                        </Button>
                    </div>
                </Col>
                <Col sm={12} md={6} className="pl-md-0 contact-card-second-column" style={{ backgroundImage: `url(${imageSource})` }} />
            </Row>
        </Card>
    );
};

ContactCard.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    link: PropTypes.shape({
        link: PropTypes.string,
        text: PropTypes.string,
    }),
    imageSource: PropTypes.string,
};

export default ContactCard;
